// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  narrationId: __t.u64().primaryKey().name("narration_id"),
  receiptId: __t.u64().name("receipt_id"),
  script: __t.string(),
  artefactUrl: __t.option(__t.string()).name("artefact_url"),
  kind: __t.string(),
  createdAt: __t.i64().name("created_at"),
});
